module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/DailyPrecipitation100/Kanagawa_DailyPrecipitation100_MRI_RCP85_End.png";